/**
 * The two ceilings a Clarity document is measured against, in one place (port source
 * `shared/config/limits.ts` → `FILE_SIZE_LIMITS`, `FILE_SIZE_LIMITS_BYTES` and `PDF_LIMITS`).
 *
 * **The size cap is independent of the request cap.** The browser uploads a document straight to
 * object storage with a signed `PUT`, so it never travels inside a chat request and is not bounded by
 * the 50 MB one that is — which is why 100 MB here is not a contradiction of anything.
 *
 * **The page cap is the product's reading ceiling, not a provider constant.** A longer PDF still
 * uploads and is still stored; what it does not get is the agent reading past page
 * {@link CLARITY_DOCUMENT_LIMITS.PDF_MAX_PAGES}, and the refusal the reader sees says so.
 *
 * It lives in `util-clarity` because four surfaces in three libraries measure against it — the
 * composer's own validation, the Open Items attach flow and both page-limit refusals — and the one
 * thing that must never happen is two of them disagreeing. Every consumer reads these members;
 * nothing restates the numbers.
 */
export const CLARITY_DOCUMENT_LIMITS = {
	MAX_MB: 100,
	MAX_BYTES: 100 * 1024 * 1024,
	PDF_MAX_PAGES: 600,
} as const;
